import React from 'react';
import { SortDir } from '@fabric-ui/components';
import { emptyObject } from '@fabric-ui/utils';
import { Box, SxProps } from '@mui/material';
import { useFilterContext } from '../FilterContext';

interface TopKDisplayProps {
  metric: string;
  top: number;
  dir: SortDir;
  dim?: string;
  style?: SxProps;
}

const TopKDisplay = ({ metric, top, dir, dim, style = emptyObject }: TopKDisplayProps) => {
  const { accountEntities, measurements } = useFilterContext();
  const fieldMap = accountEntities?.fieldMap ?? {};

  return (
    <Box sx={{ fontSize: 12, ...style }}>
      <b>{`${dir === SortDir.DESC ? 'Top' : 'Bottom'} ${top} `}</b>
      {!!dim && fieldMap[dim].title}
      {` by ${measurements.asObject[metric]?.displayName || metric}`}
    </Box>
  );
};

export default TopKDisplay;
